<template>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-drag-handle"
  >
    <circle
      cx="8"
      cy="6"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="16"
      cy="6"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="8"
      cy="12"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="16"
      cy="12"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="8"
      cy="18"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="16"
      cy="18"
      r="1.5"
      fill="currentColor"
    />
  </svg>
</template>
